// Θέση συμβόλου €: στα Ελληνικά μετά τον αριθμό (5€), στα Αγγλικά πριν (€5),
// στα Γερμανικά, Ιταλικά και Γαλλικά μετά τον αριθμό με αδιάσπαστο διάστημα (5 €).
const NNBSP = ' '; // αδιάσπαστο διάστημα: δεν σπάει η γραμμή ανάμεσα σε αριθμό και €

export const money = (amount, language) => {
  if (language === 'de' || language === 'it' || language === 'fr') return `${amount}${NNBSP}€`;
  if (language === 'gr') return `${amount}€`;
  return `€${amount}`;
};
